@import '../../styles/modal-loading-overlay.css';
@import '../../styles/buttons.css';

:host {
  display: block;
  min-height: 100%;
}

.activity-type { margin: 15px 0 50px; }

.activity-type-title {
  font-size: 12px;
  padding: 12px 15px 20px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #666;
}

.activity-order {
  border-top: 1px solid rgba(0,0,0,0.1);
  padding: 15px;
  display: flex;
  letter-spacing: 0.6px;
}

.activity-order-left-col {
  flex-grow: 1;
  line-height: 20px;
  padding-right: 15px;
}

.order-business-title { font-weight: bold; }
.order-time { font-weight: bold; }
.order-payment-method { text-transform: capitalize; font-weight: bold; }

.order-header {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
}

.order-id { font-size: 15px; }

.order-label {
  padding: 3px 5px;
  line-height: 13px;
  background-color: #dedede;
  border-radius: 5px;
  cursor: default;
  font-size: 11px;
  text-decoration: none;
  color: #555;
  white-space: nowrap;
}

.order-label.warning { 
  background-color: var(--tambr-warn-color, #db0e09);
}

.activity-order-right-col {
  text-align: right;
  line-height: 16px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}


.no-orders {
  padding: 50px 20px 10px;
  text-align: center;
}

.cancel-button {
  font-size: 12px;
  letter-spacing: 0.4px;
  text-decoration: underline;
  cursor: pointer;
  color: #db0e09;
}

.update-button {
  font-size: 12px;
  letter-spacing: 0.4px;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
  color: #6c6c6c;
}

